import React, { useEffect } from 'react';
import styled from 'styled-components';
import cx from 'classnames';
import { useFormikContext } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Select } from '@futurefamily/ef-components';

const TERMS = [24, 36, 48, 60];

const ButtonGrid = styled.div`
  display: none;

  @media (min-width: 768px) {
    display: grid;

    grid-template-columns: repeat(4, 1fr);
    column-gap: 33px;
  }
`;

const TermButton = styled(Button)`
  font-size: 1rem;
  font-weight: 700;
  padding: 7px 20px;

  &.active {
    background-color: var(--brown);
  }
`;

function TermSelector (props) {
  const { values, setFieldValue } = useFormikContext();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    if (query.get('term') === values.term) { return; }

    query.set('term', values.term);

    history.replace({
      search: query.toString()
    });
  }, [values.term, location.search, history]);

  return (
    <div {...props}>
      <ButtonGrid>
        {TERMS.map(t => (
          <TermButton
            key={t}
            type="button"
            className={cx({ active: values.term === t })}
            onClick={() => setFieldValue('term', t)}
          >
            {t} Months
          </TermButton>
        ))}
      </ButtonGrid>

      <Select className="mb-4 d-md-none" name="term">
        <option value="">Select one...</option>
        {TERMS.map(t => (
          <option key={t} value={t}>{t} Months</option>
        ))}
      </Select>
    </div>
  );
}

export default TermSelector;
